import { Typography, useMediaQuery } from '@mui/material';
import { BooleanField, CreateButton, Datagrid, ImageField, List, NumberField, SimpleList, TextField, useResourceContext } from 'react-admin';

const PlanList = () => {
	const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
	const context = useResourceContext({ resource: 'ai-program' });
	return (
		<List resource="ai-program" hasCreate actions={<CreateButton resource="ai-program" />}>
			{isSmall ? (
				<SimpleList
					resource={context}
					primaryText={(record) => (
						<Typography textAlign="right" fontWeight={'600'}>
							{`${record.title?.he || record._id}`}
						</Typography>
					)}
					secondaryText={(record) => <Typography>{record.sub_title?.he || ''}</Typography>}
				/>
			) : (
				<Datagrid dir="rtl" rowClick="edit" resource="ai-program">
					<ImageField source="image" label="תמונה" />
					<TextField source="title.he" textAlign="right" label="כותרת (עברית)" />
					<TextField source="title.en" textAlign="left" label="כותרת (אנגלית)" />
					<TextField source="sub_title.he" textAlign="right" label="תת כותרת (עברית)" />
					<TextField source="sub_title.en" textAlign="left" label="תת כותרת (אנגלית)" />
					<NumberField source="days" textAlign="center" label="ימים" />
					<NumberField source="amount" textAlign="center" label="כמות תכנים" />
					<NumberField source="videoamount" textAlign="center" label="וידאו" />
					<NumberField source="missionamount" textAlign="center" label="משימות" />
					<NumberField source="expertamount" textAlign="center" label="מומחים" />
					<BooleanField source="active" textAlign="center" label="פעיל" />
				</Datagrid>
			)}
		</List>
	);
};

export default PlanList;
